import { Callout, Link } from "@vitality-ds/components";
import React from "react";

import InlineCode from "../InlineCode";
import { Container, Paragraph } from "./styled";
import { DeprecationBannerProps } from "./types";

function DeprecationBanner({
  reserveTocSpace,
}: DeprecationBannerProps): JSX.Element {
  return (
    <Container
      as="aside"
      aria-label="Site notice"
      reserveTocSpace={reserveTocSpace}
    >
      <Callout
        severity="warning"
        title="Vitality is evolving: this documentation is deprecated"
        description={
          <>
            <Paragraph>
              Vitality is undergoing a major overhaul. We are rebuilding the
              tokens and components we provide around composability,
              compatibility, and independence from any single component
              rendering technology, and revisiting every design decision
              Vitality has made across the last four years as we go.
            </Paragraph>
            <Paragraph>
              As a result, every{" "}
              <InlineCode variant="fade">@vitality-ds/*</InlineCode> library is
              considered deprecated, along with the tokens, props, interaction
              states and guidance documented here.
            </Paragraph>
            <Paragraph>
              If you are still consuming those packages, this site remains the
              correct reference for the version you have installed. If you are
              not, treat it as a historical record: much of what it describes is
              being actively revisited and will not carry forward.
            </Paragraph>
            <Paragraph>
              The evolved decisions are being recorded on a new documentation
              site, currently under construction at{" "}
              <Link
                href="https://react.vitalitydesignsystem.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                react.vitalitydesignsystem.com
              </Link>
              .
            </Paragraph>
          </>
        }
      />
    </Container>
  );
}

export default DeprecationBanner;
